import { Tooltip } from '@material-ui/core';
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import useTextStyle from '../TemplateTextStyle';

const MissingValueTag = ({ tooltip, text, onRemove }) => {
    const classes = useTextStyle({
        isValueMissing: true,
    });

    return (
        <Tooltip className={classes.tooltip} title={t(tooltip)}>
            <span className={classes.root} tabIndex={0}>
                {text}
                <span className={classes.actions}>
                    <FontAwesomeIcon
                        className={classes.icon}
                        icon='times'
                        data-test-id='template-text-remove-button'
                        onFocus={(e) => e.stopPropagation()}
                        onClick={(e) => {
                            e.stopPropagation();
                            onRemove();
                        }}
                    />
                </span>
            </span>
        </Tooltip>);
};

MissingValueTag.propTypes = {
    text: PropTypes.string,
    tooltip: PropTypes.string,
    onRemove: PropTypes.func,
};

export default MissingValueTag;
